export default "__VITE_ASSET__BQvNUBy3__"